var scopeList=[
  {
    "name": "旅店",
    "parent": null,
    "scopeid": 0,
    "scopelist": [
      "住宿服务",
      "客房",
      "住宿",
      "旅馆",
      "宾馆"
    ],
    "scope": "住宿服务,客房,住宿,旅馆,宾馆"
  },
  {
    "name": "宾馆",
    "parent": null,
    "scopeid": 1,
    "scopelist": [
      "住宿服务",
      "客房",
      "住宿",
      "旅馆",
      "宾馆",
      "一般旅馆",
      "宾馆"
    ],
    "scope": "住宿服务,客房,住宿,旅馆,宾馆,一般旅馆,宾馆"
  },
  {
    "name": "招待所",
    "parent": null,
    "scopeid": 2,
    "scopelist": [
      "住宿服务",
      "住宿",
      "旅馆",
      "宾馆"
    ],
    "scope": "住宿服务,住宿,旅馆,宾馆"
  },
  {
    "name": "公共浴室",
    "parent": null,
    "scopeid": 3,
    "scopelist": [
      "洗浴服务",
      "婴幼儿洗浴服务",
      "洗浴",
      "足浴服务",
      "公共浴室"
    ],
    "scope": "洗浴服务,婴幼儿洗浴服务,洗浴,足浴服务,公共浴室"
  },
  {
    "name": "理发店",
    "parent": null,
    "scopeid": 4,
    "scopelist": [
      "理发服务",
      "理发",
      "美发",
      "美发服务",
      "理发店",
      "美发店",
      "养发",
      "护发"
    ],
    "scope": "理发服务,理发,美发,美发服务,理发店,美发店,养发,护发"
  },
  {
    "name": "美容店",
    "parent": null,
    "scopeid": 5,
    "scopelist": [
      "生活美容服务",
      "美容",
      "美体",
      "美容美体",
      "美容服务",
      "美容店"
    ],
    "scope": "生活美容服务,美容,美体,美容美体,美容服务,美容店"
  },
  {
    "name": "影剧院",
    "parent": null,
    "scopeid": 8,
    "scopelist": [
      "电影放映"
    ],
    "scope": "电影放映"
  },
  {
    "name": "录像厅（室）",
    "parent": null,
    "scopeid": 9,
    "scopelist": [
      "电影放映",
      "歌舞娱乐活动",
      "游艺娱乐活动",
      "演出场所经营"
    ],
    "scope": "电影放映,歌舞娱乐活动,游艺娱乐活动,演出场所经营"
  },
  {
    "name": "游艺厅（室）",
    "parent": null,
    "scopeid": 10,
    "scopelist": [
      "电影放映",
      "歌舞娱乐活动",
      "游艺娱乐活动",
      "演出场所经营",
      "电子游艺娱乐服务",
      "娱乐及体育设备出租"
    ],
    "scope": "电影放映,歌舞娱乐活动,游艺娱乐活动,演出场所经营,电子游艺娱乐服务,娱乐及体育设备出租"
  },
  {
    "name": "舞厅",
    "parent": null,
    "scopeid": 11,
    "scopelist": [
      "电影放映",
      "歌舞娱乐活动",
      "游艺娱乐活动",
      "演出场所经营"
    ],
    "scope": "电影放映,歌舞娱乐活动,游艺娱乐活动,演出场所经营"
  },
  {
    "name": "音乐厅",
    "parent": null,
    "scopeid": 12,
    "scopelist": [
      "电影放映",
      "歌舞娱乐活动",
      "游艺娱乐活动",
      "演出场所经营",
      "歌舞厅娱乐活动",
      "综合娱乐",
      "歌舞娱乐",
      "歌厅"
    ],
    "scope": "电影放映,歌舞娱乐活动,游艺娱乐活动,演出场所经营,歌舞厅娱乐活动,综合娱乐,歌舞娱乐,歌厅"
  },
  {
    "name": "展览馆",
    "parent": null,
    "scopeid": 13,
    "scopelist": [
      "文化场馆管理服务"
    ],
    "scope": "文化场馆管理服务"
  },
  {
    "name": "博物馆",
    "parent": null,
    "scopeid": 14,
    "scopelist": [
      "文化场馆管理服务"
    ],
    "scope": "文化场馆管理服务"
  },
  {
    "name": "美术馆",
    "parent": null,
    "scopeid": 15,
    "scopelist": [
      "文化场馆管理服务"
    ],
    "scope": "文化场馆管理服务"
  },
  {
    "name": "图书馆",
    "parent": null,
    "scopeid": 16,
    "scopelist": [
      "文化场馆管理服务"
    ],
    "scope": "文化场馆管理服务"
  },
  {
    "name": "游泳场（馆）",
    "parent": null,
    "scopeid": 17,
    "scopelist": [
      "高危险性体育运动（游泳）"
    ],
    "scope": "高危险性体育运动（游泳）"
  },
  {
    "name": "候车（机、船）室",
    "parent": null,
    "scopeid": 19,
    "scopelist": [
      "铁路运输辅助服务",
      "道路旅客运输站经营"
    ],
    "scope": "铁路运输辅助服务,道路旅客运输站经营"
  },
  {
    "name": "商场(店)",
    "parent": null,
    "scopeid": 20,
    "scopelist": [
      "日用百货销售",
      "零售",
      "出版物零售"
    ],
    "scope": "日用百货销售,零售,出版物零售"
  }
]

export default scopeList